const isMRN = false;
const DEFAULT_CITY_ID = 1;
export function getActuralCityId(props) {
    var _a, _b;
    const { ctx } = props;
    const runtimeInfo = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo;
    const queryParams = runtimeInfo === null || runtimeInfo === void 0 ? void 0 : runtimeInfo.queryParams;
    const commonParams = runtimeInfo === null || runtimeInfo === void 0 ? void 0 : runtimeInfo.commonParams;
    // 优先从查询参数获取城市id
    if (queryParams === null || queryParams === void 0 ? void 0 : queryParams.cityId) {
        console.log('get cityid from jumpUrl', queryParams.cityId);
        return {
            cityId: Number(queryParams.cityId),
            type: 'queryParams'
        };
    }
    // 获取小环境城市
    // 从美团首页获取城市
    if ((_a = commonParams === null || commonParams === void 0 ? void 0 : commonParams.cityInfo) === null || _a === void 0 ? void 0 : _a.cityId) {
        console.log('get cityid from commonParams', commonParams.cityInfo.cityId);
        return {
            cityId: Number(commonParams.cityInfo.cityId),
            type: 'homePage'
        };
    }
    // 从定位获取城市
    if ((_b = commonParams === null || commonParams === void 0 ? void 0 : commonParams.cityInfo) === null || _b === void 0 ? void 0 : _b.locCityId) {
        console.log('get loc cityId from commonParams', commonParams.cityInfo.locCityId);
        return {
            cityId: Number(commonParams.cityInfo.locCityId),
            type: 'locCityId'
        };
    }
    return {
        cityId: DEFAULT_CITY_ID,
        type: 'default'
    };
}
export function debounce(fn, delay) {
    let timer = null;
    return function (...args) {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            fn.apply(this, args);
            timer = null;
        }, delay);
    };
}
